// src/components/pages/sections/OverviewUsersChart.js
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// Helper to aggregate users per day
function getUsersPerDay(data) {
    const usersByDay = {};
    data.forEach(d => {
        if (!d.view_date) return;
        const day = d.view_date.slice(0, 10);
        if (!usersByDay[day]) usersByDay[day] = new Set();
        usersByDay[day].add(d.viewer_id);
    });
    // Convert to sorted array of [date, count]
    return Object.entries(usersByDay)
        .map(([date, users]) => [date, users.size])
        .sort((a, b) => a[0].localeCompare(b[0]));
}

const OverviewUsersChart = ({ data }) => {
    const usersPerDay = getUsersPerDay(data);

    const options = {
        title: { text: 'Number of Users Per Day' },
        xAxis: {
            type: 'category',
            title: { text: 'Date' },
            labels: { style: 
                {
                    rotation: -45,
                }
            }
        },
        yAxis: {
            title: { text: 'Users' },
            allowDecimals: false
        },
        series: [{
            name: 'Users',
            data: usersPerDay,
            type: 'line'
        }],
        chart: { height: 300 }
    };

    return (
        // <div className="dashboard-overview-element chart-container">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 overflow-x-auto">
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
    );
};

export default OverviewUsersChart;